import React from 'react';
import { Label } from '@/components/ui/label';
import DoctorBookingOverrides from './DoctorBookingOverrides';

function Toggle({ id, label, hint, checked, onChange }) {
  return (
    <label htmlFor={id} className="flex items-start gap-3 py-2 cursor-pointer">
      <input
        id={id}
        type="checkbox"
        className="mt-1 h-4 w-4 rounded border-zinc-300"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span>
        <span className="block text-sm font-medium text-zinc-800">{label}</span>
        {hint ? <span className="block text-[11px] text-zinc-500 mt-0.5">{hint}</span> : null}
      </span>
    </label>
  );
}

/** Booking eligibility + portal privacy toggles. */
export default function ProfilePrivacyBooking({ privacy, booking, onPrivacy, onBooking }) {
  return (
    <div className="grid md:grid-cols-2 gap-6" data-testid="profile-privacy-booking">
      <div>
        <Label className="text-xs uppercase tracking-wider text-zinc-500">Appointments</Label>
        <div className="mt-2 rounded-lg border bg-zinc-50/80 px-3">
          <Toggle
            id="bk-accept"
            label="Accept appointments"
            hint="Patients / reception can book slots with this staff member."
            checked={booking.accept_appointments}
            onChange={(v) => onBooking({ ...booking, accept_appointments: v })}
          />
          <Toggle
            id="bk-portal"
            label="Bookable from patient portal"
            hint="Online OPD booking is limited to General Physicians. Specialists stay listed but are not bookable online."
            checked={booking.patient_portal_booking}
            onChange={(v) => onBooking({ ...booking, patient_portal_booking: v })}
          />
          <Toggle
            id="bk-referral"
            label="Can provide referral"
            hint="Also required for specialists. Duty medical officers / residents on today’s published roster appear automatically when seeking a referral."
            checked={!!booking.can_provide_referral}
            onChange={(v) => onBooking({ ...booking, can_provide_referral: v })}
          />
          <DoctorBookingOverrides booking={booking} onBooking={onBooking} />
        </div>
      </div>
      <div>
        <Label className="text-xs uppercase tracking-wider text-zinc-500">Portal privacy</Label>
        <div className="mt-2 rounded-lg border bg-zinc-50/80 px-3 max-h-56 overflow-y-auto">
          <Toggle id="pv-portal" label="Show profile on portal" checked={privacy.show_on_portal}
            onChange={(v) => onPrivacy({ ...privacy, show_on_portal: v })} />
          <Toggle id="pv-photo" label="Show photograph" checked={privacy.show_photo}
            onChange={(v) => onPrivacy({ ...privacy, show_photo: v })} />
          <Toggle id="pv-title" label="Show title" checked={privacy.show_title}
            onChange={(v) => onPrivacy({ ...privacy, show_title: v })} />
          <Toggle id="pv-spec" label="Show specialisation" checked={privacy.show_specialization}
            onChange={(v) => onPrivacy({ ...privacy, show_specialization: v })} />
          <Toggle id="pv-qual" label="Show qualifications" checked={privacy.show_qualifications}
            onChange={(v) => onPrivacy({ ...privacy, show_qualifications: v })} />
          <Toggle id="pv-bio" label="Show biography" checked={privacy.show_bio}
            onChange={(v) => onPrivacy({ ...privacy, show_bio: v })} />
          <Toggle id="pv-phone" label="Show phone on portal" hint="Off by default."
            checked={privacy.show_phone}
            onChange={(v) => onPrivacy({ ...privacy, show_phone: v })} />
        </div>
      </div>
    </div>
  );
}
